import { HTag } from '@app/components/ui-kit/MyHtag';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import classNames from 'classnames';

import styles from './TitleList.module.scss';

interface IProps {
  title: string;
  text?: string;
  className?: string;
}

export const TitleList = ({ title, text, className }: IProps) => {
  const isMobile = useWindowSizing(990);
  return (
    <div className={classNames(styles.Wrapper, className)}>
      <HTag tag="h1">{title}</HTag>
      <p>{isMobile && text}</p>
    </div>
  );
};
